import { Pipe, PipeTransform } from '@angular/core';

const PAYMENT_TYPE_DISPLAY: Record<string, string> = {
  amex: 'American Express',
  diners: 'Diners Club',
  discover: 'Discover',
  jcb: 'JCB',
  mastercard: 'Mastercard',
  unionpay: 'UnionPay',
  visa: 'Visa',
  paypal: 'PayPal',
  revolut_pay: 'Revolut Pay',
  sofort: 'SOFORT',
  alipay: 'Alipay',
  wechat_pay: 'WeChat Pay',
  boleto: 'Boleto',
  afterpay_clearpay: 'Afterpay/Clearpay',
  fpx: 'FPX',
  eps: 'EPS',
  giropay: 'Giropay',
  ideal: 'iDEAL',
  bancontact: 'Bancontact',
  sepa_debit: 'SEPA Direct Debit',
  au_becs_debit: 'BECS Direct Debit',
  bacs_debit: 'BACS Direct Debit',
  p24: 'Przelewy24',
  netbanking: 'Netbanking',
  grabpay: 'GrabPay',
  oxxo: 'OXXO',
};

@Pipe({
  name: 'paymentName',
  standalone: false,
  pure: true,
})
export class PaymentNamePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    return (
      PAYMENT_TYPE_DISPLAY[value] ??
      value.charAt(0).toUpperCase() + value.slice(1)
    );
  }
}
